import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

const villageLandParcelDetails = createSlice({
    name: "villageLandParcelDetails",
    initialState,
    reducers: {
        fetchLandParcelDetailsStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchLandParcelDetailsSuccess(state, action) {
            console.log("fetchDataSuccess sites success");
            state.loading = false;

            const tempData = action.payload;
            state.data = tempData;
            console.log("Sites details are", state.data)
            console.log("fetchDataSuccess sites success data");
        },
        fetchLandParcelDetailsFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    fetchLandParcelDetailsStart,
    fetchLandParcelDetailsSuccess,
    fetchLandParcelDetailsFailure,
} = villageLandParcelDetails.actions;
export default villageLandParcelDetails.reducer;
